module.exports = __webpack_public_path__ + "img/microplastics-process-1.2b417fcf.png";